// types
import { i18nSystemCodebooks } from 'models/i18n';
import { ReservedCapacityGuardingCheckResultStatus } from 'views/modules/Dispatcher/RkDashboard/rkDashboardTypes';
import { ReservedCapacityGuardingActionTypeEnum } from 'features/dispatcher/dispatcherReservedCapacityGuardingTypes';
import { ActivityLogEventCode } from 'models/dispatcher';

const enSystemCodebooks: i18nSystemCodebooks = {
  ElectricalPowerUnit: {
    W: {
      title: 'W'
    },
    kW: {
      title: 'kW'
    },
    MW: {
      title: 'MW'
    },
    GW: {
      title: 'GW'
    }
  },
  PredictionErrorCode: {
    WEATHER_DATA_NOT_AVAILABLE: {
      title:
        'The weather data is unavailable, and interpolated values have been used'
    },
    LOW_RELIABILITY_INCOMPLETE_INPUT_DATA_INTERPOLATING: {
      title:
        'Incomplete input data - the missing value was filled in by interpolation'
    },
    LOW_RELIABILITY_INCOMPLETE_INPUT_DATA_FILL_WITH_CONSTANT: {
      title:
        'Incomplete input data, and interpolation was unsuccessful - the missing value was filled in with a constant.'
    },
    LOW_RELIABILITY_OPTIMIZATION_UNFINISHED: {
      title:
        'The optimization did not find an optimal solution. A solution was proposed that may not be optimal'
    },
    LOW_RELIABILITY_OTHER: {
      title: 'Low reliability of the proposed optimization due to other reasons'
    },
    NOK: { title: 'An unexpected error occurred' },
    OK: { title: 'OK' },
    NOK_OPTIMIZATION_INFEASIBLE: {
      title:
        'The optimization software failed to return any solution to the optimization problem'
    },
    MISSING_CRITICAL_INPUT_DATA_EXCLUDING_DEVICE: {
      title:
        'Critical data was unavailable, the device is excluded from further optimization processing'
    },
    MISSING_CRITICAL_INPUT_DATA_OPTIMIZATION_FAILED: {
      title: 'No result was provided for the data point due to an error'
    },
    UNSUPPORTED_TOPOLOGY_OF_BALANCE_GROUP: {
      title: 'Unsupported topology of the balancing group'
    }
  },
  EntsoeSystemImbalanceLoadingType: {
    intermediate: { title: 'intermediate' },
    final: { title: 'final' }
  },
  EntsoeWeatherEnergyType: {
    wind: { title: 'wind energy' },
    solar: { title: 'solar energy' }
  },
  OkteSystemImbalanceLoadingType: {
    preliminarydaily: { title: 'preliminary daily' },
    regulardaily: { title: 'regular daily' }
  },
  OperationEvent: {
    str_PWD: { title: 'Loss of power supply voltage' },
    por_charg: { title: 'Battery charging fault' },
    por_bat: { title: 'Battery fault' },
    str_sig_U: { title: 'Loss of signaling and control voltage' },
    kom_elm_prah: {
      title: 'Communication fault with the meter at the OOM threshold'
    },
    kom_elm_svorky: {
      title:
        'Communication fault with the terminal meter of the power source/device'
    },
    ovl_miestne: { title: 'Local control of OOM' },
    HRM_BLOK: {
      title: 'HRM blocked by the dispatch of the distribution company'
    },
    por_ochr: { title: 'Protection fault' },
    GP: { title: 'Operation of protection' },
    FU_por: { title: 'Blown fuse' },
    por: { title: 'Device fault' },
    kom_BESS: { title: 'Communication fault of the battery storage' }
  },
  ReservedCapacityGuardingCheckResultStatus: {
    [ReservedCapacityGuardingCheckResultStatus.ACTIONS_NOT_NEEDED]: {
      title: 'No actions are needed'
    },
    [ReservedCapacityGuardingCheckResultStatus.ACTIONS_ISSUED]: {
      title: 'Actions have been issued'
    },
    [ReservedCapacityGuardingCheckResultStatus.ACTIONS_ISSUED_RESERVED_CAPACITY_EXCEEDED]:
      {
        title:
          'Actions have been issued, but reserved capacity will be exceeded'
      },
    [ActivityLogEventCode.RESERVED_CAPACITY_EXCEEDED_NO_ACTIONS_POSSIBLE]: {
      title: 'Reserved capacity exceeded, no actions possible'
    }
  },
  ReservedCapacityGuardingActionType: {
    [ReservedCapacityGuardingActionTypeEnum.Increase]: {
      title: 'Increase'
    },
    [ReservedCapacityGuardingActionTypeEnum.Reduction]: {
      title: 'Reduction'
    }
  }
};

export default enSystemCodebooks;
